import React from "react";
import { Routes, Route, useParams } from "react-router-dom";
import Home from "./pages/Home/Home.jsx";
import Informatique from "./pages/Informatique/Informatique.jsx";
import Telephonie from "./pages/Telephonie/Telephonie.jsx";
import MentionLegal from "./pages/Mention_Legal/Mention_Legal.jsx";
import Internet from "./pages/Internet/Internet.jsx";
import Logiciel from "./pages/Logiciel/Logiciel.jsx";
import Cours from "./pages/Cours/Cours.jsx";
import Mobile from "./pages/Telephonie/Telephone/Mobile/Mobile.jsx";
import Nas from "./components/Ordinateur/Nas/Nas.jsx";
import PcPortable from "./components/Ordinateur/Pc-Portable/PcPortable.jsx";
import NotFound from "./pages/NotFound/NotFound.jsx";
import PcFixe from "./components/Ordinateur/Pc-Fixe/PcFixe.jsx";
import Telephone from "./pages/Telephonie/Telephone/Telephone.jsx";
import Medical from "./components/Ordinateur/Medical/Medical.jsx";
import Serveur from "./components/Ordinateur/Serveur/Serveur.jsx";
import TelephoneFixe from "./components/TelephoneFixe/TelephoneFixe.jsx";
import Telephone_mobile from "./pages/Telephonie/Telephone/Telephone_Mobile/Telephone_mobile.jsx";
import Infogerance from "./components/Infogerance/Infogerance.jsx";
import Infrastructure from "./components/Infrastructure/Infrastructure.jsx";
import Sauvegarde from "./components/Sauvegarde/Sauvegarde.jsx";
import Ordinateur from "./components/Ordinateur/Materiel_Et_Vente.jsx";
import TechGame from "./pages/TechGame/TechGame.jsx";
import Dev from "./pages/Dev/Dev.jsx"

/**
 * WRAPPER POUR LE SEO LOCAL
 * Ce composant extrait la ville de l'URL et la passe au composant Infrastructure
 */
const InfrastructureCityWrapper = ({ openTarifs }) => {
  const { ville } = useParams();
  return <Infrastructure openTarifs={openTarifs} ville={ville} />;
};

function Router({ openTarifs }) {
  return (
    <Routes>
      {/* --- ACCUEIL --- */}
      <Route path="/" element={<Home />} />

      {/* --- PAGES PRINCIPALES --- */}
      <Route path="/informatique" element={<Informatique />} />
      <Route path="/telephonie" element={<Telephonie />} />
      <Route path="/internet" element={<Internet />} />
      <Route path="/logiciel" element={<Logiciel />} />
      <Route path="/ordinateur" element={<Ordinateur />} />
      <Route path="/dev" element={<Dev />} />
      <Route path="/mentionlegal" element={<MentionLegal />} />
      
      {/* --- SERVICES INFRASTRUCTURE --- */}
      {/* Route standard */}
      <Route path="/infrastructure" element={<Infrastructure openTarifs={openTarifs} />} />
      
      {/* ROUTE SEO LOCAL (DYNAMIQUE) : permettra d'avoir /infrastructure-epinal, /infrastructure-remiremont, etc. */}
    <Route path="/infrastructure/:ville" element={<InfrastructureCityWrapper />} />

      {/* --- AUTRES SERVICES --- */}
      <Route path="/infogerance" element={<Infogerance />} />
      <Route path="/sauvegarde" element={<Sauvegarde />} />
      <Route path="/nas" element={<Nas />} />
      <Route path="/pc-portable" element={<PcPortable />} />
      <Route path="/pc-fixe" element={<PcFixe />} />
      <Route path="/telephone" element={<Telephone />} />
      <Route path="/medical" element={<Medical />} />
      <Route path="/mobile" element={<Mobile />} />
      <Route path="/fixe" element={<TelephoneFixe />} />
      <Route path="/serveur" element={<Serveur />} />
      <Route path="/telmobile" element={<Telephone_mobile />} />
      <Route path="/techgame" element={<TechGame />} />

      {/* --- ERREUR 404 --- */}

    </Routes>
  );
}

export default Router;